import { baseRestApi } from "api/rest/baseRestApi";

const API_ROOT = "/greenscreens/auth/token";
module.hot?.accept();

type Response = {
  access_token: string;
};

const getGreenscreensAuthTokenApi = baseRestApi.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",

  endpoints: (builder) => ({
    getGreenscreensAuthToken: builder.mutation<Response, void>({
      query: () => ({
        url: `${API_ROOT}`,
        method: "POST",
      }),
    }),
  }),
});

export default getGreenscreensAuthTokenApi;

export const { useGetGreenscreensAuthTokenMutation } = getGreenscreensAuthTokenApi;
